var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardTrophyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31,13.5H9a3,3,0,0,1,0-6V6a3,3,0,0,1,3-3H24a3,3,0,0,1,3,3V7.5a3,3,0,0,1,0,6h-.31a8.256,8.256,0,0,1-7.19,5.967V25.5H21a3,3,0,0,1,3,3V30h1.5a1.5,1.5,0,0,1,0,3h-15a1.5,1.5,0,0,1,0-3H12V28.5a3,3,0,0,1,3-3h1.5V19.467A8.256,8.256,0,0,1,9.31,13.5ZM12,6v5.25a5.25,5.25,0,0,0,5.25,5.25h1.5A5.25,5.25,0,0,0,24,11.25V6Z",
    transform: "translate(-6 -3)",
    fill: "#2cccd3",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTrophyIcon);
export default __webpack_public_path__ + "static/media/dashboard-trophy-icon.784de7f8.svg";
export { ForwardRef as ReactComponent };